import Vue from "vue"
import i18n from "@/i18n"

Vue.filter( "i18n", label => i18n.t( label ) )
Vue.filter( "showDate", date => ( moment( date ).isValid() )? moment( date ).format( "DD-MM-YYYY" ) : i18n.t( 'date.invalid') )
Vue.filter( "showHour", date => ( moment( date ).isValid() )? moment( date ).format( "DD-MM-YYYY HH:mm" ) : i18n.t( 'date.invalid') )
Vue.filter( "checkDate", date => ( moment( date ).isValid() )? moment( date ).format( "DD-MM-YYYY" ) : undefined )
Vue.filter( "checkParam", value => {
    //console.log( value + " " + typeof value )
    // console.log( value + " " + typeof value )
    if( value == null || ( typeof value == 'string' && value.trim() == '' ) ) return '-'
    else{
        var type = typeof value
        if( value == "true" || value == "false" ) type = 'boolean'

        //console.log( value + " " + type )
        // console.log( value + " " + type )

        switch( type ) {
            case 'boolean': return i18n.t( ( value == 'true' || value === true )? 'si' : 'no' )
            default: return value
        }
    }
})
Vue.filter( 'eventEditionName', event => event.name + "'" + event.edition.substring(2) )